import React, { useState, useEffect, useContext } from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Typography from "@mui/material/Typography";
import styles from "../../components/Main/styles.module.css";
import logo from "../../images/logoBrancoPrincipal.png";
import Link from '@mui/material/Link';
import LogoutIcon from '@mui/icons-material/Logout';
import { ItemsMenu, NomeCompleto, Token } from "../../utils/localStorage.util";

import { Context } from "../../config/AuthContext";
import { useNavigate } from "react-router-dom";

import {
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Collapse,
} from "@mui/material";
import { ExpandLess, ExpandMore, Summarize } from "@mui/icons-material";
import ProcessosInternos from ".";
import apiAutenticacao, { getMenuList } from "../../services/api-relatorios.service";

const drawerWidth = 240;

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  })
);

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

export default function PersistentDrawerLeft() {
  const [path, setPath] = useState('') 
  const [nameFile, setNameFile] = useState('') 
  const theme = useTheme();
  const [open, setOpen ] = React.useState(true);

  const navigate = useNavigate();

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleGetMenu = async () => {
    try{
        const response = await getMenuList()
        return response;
    }catch(error){
        console.log(error)
    }
  }

  const [menuItems, setMenuItems] = useState([]);

  const [openMenus, setOpenMenus] = useState([]);
  
  useEffect(() => {
    async function handleMenu(){
        const response = await handleGetMenu();
        setMenuItems(response.menu);
    }
    handleMenu();
  }, []);

  const handleMenuClick = (menuId) => {
    if (openMenus.includes(menuId)) {
      setOpenMenus(openMenus.filter((id) => id !== menuId));
    } else {
      setOpenMenus([...openMenus, menuId]);
    }
  };

  const handleSubmenuClick = (submenu) => {
    setPath(submenu.path)
    setNameFile(submenu.name)
  }

  const toDashboard = () => {
    navigate("/dashboard")
  }

  const renderSubmenus = (submenus) => (
    <List>
      {submenus.map((submenu) => (
        <ListItem key={submenu.order} disablePadding>
          <ListItemButton
            onClick={() => handleSubmenuClick(submenu)}
          >
            <ListItemText primary={submenu.name} />
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  );

  return (
    <div>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppBar position="fixed" open={open}>
          <Toolbar
              className={styles.menuPrincipal}
              sx={{ 
                display: "grid",
                gridGap: 20,
                ...(open && { gridTemplateColumns: "repeat(2, 1fr)" }),
                ...(!open && { gridTemplateColumns: "repeat(3, 1fr)" })
              }}
            >
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={handleDrawerOpen}
                sx={{ 
                  mr: 2,
                  justifySelf: "flex-start",
                  ...(open && { display: "none" })
                }}
              >
                <MenuIcon />
              </IconButton>
              <Box sx={{ 
                display: "flex", 
                ...(!open && { justifyContent: "center" })
              }}>
                <Link 
                  component="button"
                  onClick={toDashboard}>
                  <img src={logo} className={styles.logoMenu} alt="Logo"></img>
                </Link>
              </Box>
              <Box sx={{ 
                display: "inline-flex", 
                gap: "20px",
                justifySelf: "flex-end",
                alignItems: 'center',
                justifyContent: 'center', 
              }}>
              </Box>
            </Toolbar>
        </AppBar>
        <Drawer
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              boxSizing: "border-box"
            },
          }}
          variant="persistent"
          anchor="left"
          open={open}
        >
          <DrawerHeader 
            className={styles.cabecalhoMenuSecoes}
            sx={{
              paddingLeft: "16px",
              justifyContent: "space-between"
            }}>
            <Typography sx={{ fontWeight: "bold" }}>Menus</Typography>
            <IconButton onClick={handleDrawerClose}>
              {theme.direction === "ltr" ? (
                <ChevronLeftIcon className={styles.iconeCabecalhoMenuSecoes} />
              ) : (
                <ChevronRightIcon />
              )}
            </IconButton>
          </DrawerHeader>
          <Divider />
          <List>
            {menuItems.map((menuItem) => (
              <div key={menuItem.order}>
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => handleMenuClick(menuItem.order)}
                  >
                    <ListItemText primary={menuItem.name} 
                      primaryTypographyProps={{
                        fontWeight: 'bold',
                      }}
                    />
                    {openMenus.includes(menuItem.order) ? (
                      <ExpandLess />
                    ) : (
                      <ExpandMore />
                    )}
                  </ListItemButton>
                </ListItem>
                <Collapse
                  in={openMenus.includes(menuItem.order)}
                  timeout="auto"
                  unmountOnExit
                >
                  {renderSubmenus(menuItem.submenus)}
                </Collapse>
              </div>
            ))}
          </List>
        </Drawer>
        <Main open={open}>
          <DrawerHeader />
          <ProcessosInternos isProtected={true} path={path} name={nameFile}/>
        </Main>
      </Box>
    </div>
  );
}
